module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_maternity@2x-5c4eb890d02188272526247ba61acb92.webp";